import { Injectable, inject, signal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TenantConfigService } from '../config/tenant-config';
import { AuthService } from './auth.service';
import { IFedexInvoiceResponse, IUpdateFedexPayload, ICreateFedexAirwayResponse, IPayFedexAirwayPayload, IPayFedexAirwayResponse } from '../models/fedex.model';

@Injectable({
    providedIn: 'root',
})
export class Fedex {
    private http = inject(HttpClient);
    private tenantConfig = inject(TenantConfigService);
    private authService = inject(AuthService);
    private baseUrl = environment.platformApiUrl;

    public isPaying = signal<boolean>(false);

    private buildHeaders(isFormData = false): HttpHeaders {
        const websiteId = this.tenantConfig.settings?.['websiteId'];
        const token = this.authService.getToken() || '';

        const headersConfig: Record<string, string> = {
            'X-Tenant': websiteId ? websiteId.toString() : '',
            'tenant': websiteId ? websiteId.toString() : '',
            'token': token,
            'Authorization': `Bearer ${token}`,
        };

        if (!isFormData) {
            headersConfig['Content-Type'] = 'application/json';
        }

        return new HttpHeaders(headersConfig);
    }

    getByInvoiceNo(requestNumber: string | number): Observable<IFedexInvoiceResponse> {
        return this.http.get<IFedexInvoiceResponse>(
            `${this.baseUrl}/get-by-invoice-no/${requestNumber}`,
            { headers: this.buildHeaders() }
        );
    }

    uploadMyOwn(formData: FormData): Observable<any> {
        return this.http.post<any>(
            `${this.baseUrl}/upload-my-own`,
            formData,
            { headers: this.buildHeaders(true) }
        );
    }

    updateFedex(payload: IUpdateFedexPayload): Observable<any> {
        return this.http.put<any>(
            `${this.baseUrl}/update-fedex`,
            payload,
            { headers: this.buildHeaders() }
        );
    }

    createFedexAirwayLable(payload: IUpdateFedexPayload): Observable<ICreateFedexAirwayResponse> {
        return this.http.post<ICreateFedexAirwayResponse>(
            `${this.baseUrl}/create-fedex-airway-lable`,
            payload,
            { headers: this.buildHeaders() }
        );
    }

    payFedexAirwayInvoice(payload: IPayFedexAirwayPayload): Observable<IPayFedexAirwayResponse> {
        this.isPaying.set(true);
        return this.http.post<IPayFedexAirwayResponse>(
            `${this.baseUrl}/pay-fedex-airway-invoice`,
            payload,
            { headers: this.buildHeaders() }
        ).pipe(
            finalize(() => this.isPaying.set(false))
        );
    }
}

export { Fedex as FedexService };
